import { Spacing, Text } from '@billy/design-system'
import styled from '@emotion/styled'

export const TextWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${Spacing.S6};
`

// TODO retheming 2026 - get rid of (Text), which is an antipattern
export const TextContainer = styled(Text)`
  display: flex;
  align-items: center;
  height: 40px;
`
